import LoginEntrepriseComponent from "../../../components/entreprise/login/LoginEntrepriseComponent";



export default function LoginEntrepriseBloc() {

      return (  
        <div className="bloc-coadherent--connexion bloc-connexion shadow-bleu va-center">
            <div className="bloc-connexion--connectform bg-blanc p-lg">
                <h2 className="card-title bleu mb-lg">Se connecter à mon espace employeur</h2>
                <LoginEntrepriseComponent/>
            </div>
        </div>
    )
}